import { NotesList } from "./NotesList";
import { DocumentsList } from "./DocumentsList";
import { Divider, IconButton, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import { CSSProperties, useRef, useState } from "react";
import { Row } from "../misc/Row";
import { FlatAccordion } from "../misc/FlatAccordion";

export type NotesAndDocumentsSource = "student" | "drivingSchool";

export function NotesAndDocuments({
  showToggleButton,
  handleDrawerToggle,
  open,
  style,
  source,
}: {
  handleDrawerToggle?: () => void;
  open?: boolean;
  showToggleButton?: boolean;
  style?: CSSProperties;
  source: NotesAndDocumentsSource;
}) {
  const notesRef = useRef<{ showForm: () => void }>(null);
  const documentRef = useRef<{ showForm: () => void }>(null);
  const [showNotesSearch, setShowNotesSearch] = useState(false);
  const [notesSearchQuery, setNotesSearchQuery] = useState("");
  const [isNotesAccordionExpanded, setIsNotesAccordionExpanded] = useState(true);

  return (
    <>
      {showToggleButton && (
        <Row sx={{ alignItems: "center", justifyContent: "space-between", mb: "8px" }}>
          <Typography sx={{ flex: 1, fontWeight: "bold", fontSize: 15 }}>Notizen & Dokumente</Typography>
          <IconButton onClick={() => handleDrawerToggle?.()}>
            <ExpandMoreIcon style={{ transform: open ? "rotate(0deg)" : "rotate(180deg)" }} />
          </IconButton>
        </Row>
      )}
      <FlatAccordion buttonRef={documentRef} title="Dokumente" expandIconPosition="left">
        <DocumentsList
          ref={documentRef}
          style={style}
          resource={source === "student" ? "studentDocuments" : "drivingSchoolDocuments"}
        />
      </FlatAccordion>
      <Divider />
      <FlatAccordion
        defaultExpanded
        buttonRef={notesRef}
        title="Notizen"
        expandIconPosition="left"
        expandOnHeaderActionsClick
        onExpandedChange={setIsNotesAccordionExpanded}
        headerActions={
          <Tooltip
            title={
              !isNotesAccordionExpanded
                ? "Notizen durchsuchen"
                : showNotesSearch
                  ? "Suche schließen"
                  : "Notizen durchsuchen"
            }
          >
            <IconButton
              color="primary"
              onClick={() => {
                if (!isNotesAccordionExpanded) {
                  setShowNotesSearch(true);
                  return;
                }
                setShowNotesSearch((prev) => {
                  if (prev) {
                    setNotesSearchQuery("");
                  }
                  return !prev;
                });
              }}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
        }
      >
        <NotesList
          ref={notesRef}
          style={style}
          resource={source === "student" ? "studentNotes" : "drivingSchoolNotes"}
          showSearchField={showNotesSearch}
          searchQuery={notesSearchQuery}
          onSearchQueryChange={setNotesSearchQuery}
        />
      </FlatAccordion>
    </>
  );
}
